import React, { useEffect, useState } from 'react';
import Skeleton from '@mui/material/Skeleton';

const GetOpt = ({onLoadingChange}) => {
  const [options, setOptions] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_URL_HEADER}/Common/getSchemes`);
         const data = await response.text();
        setOptions(data);
        onLoadingChange(false); // Notify parent that loading is complete

      } catch (error) {
        console.error("Error fetching schemes:", error);
      } finally {
        setLoading(false); 
        
        onLoadingChange(false); 
      }
    };
    fetchdata();
  }, [onLoadingChange]);

  return (
    <div>
      {loading ? (
        <Skeleton   width={100} height={40} />
      ) : (
        <select name="scheme_id" id="scheme_id" dangerouslySetInnerHTML={{ __html: options }} />
      )}
    </div>
  );
};

const GetSchemes = ({ onLoadingChange }) => {
  return (
    <>
      <GetOpt onLoadingChange={onLoadingChange}/>
    </>
  );
}

export default GetSchemes;